import React from "react";
import createReactClass from "create-react-class";
import moment from "moment";

// import MessageGroupsUser from "./message_groups_users";

export default createReactClass({
  displayName: "Root",
  getInitialState() {
    return {};
  },
  fullname_disp(user){
    if (this.props.isCompany) {
      return `${user.familyname} ${user.firstname}`
    }
    if (user.is_fullname_hidden && user.is_verified_identity){
      return `@${user.tunagate_id}(本人確認済)`;
    }
    else if (!user.is_fullname_hidden && user.is_verified_identity){
      return  `${user.familyname} ${user.firstname}(本人確認済)`
    }
    else{
      return `${user.familyname} ${user.firstname}`
    }
  },
  render() {
    var lastMessageFormatted = "";
    if (this.props.lastMessage) {
      var now = moment();
      var createdDay = moment(this.props.lastMessage.created_at);
      if (now.isSame(createdDay, "days")) {
        lastMessageFormatted = createdDay.format("HH:mm");
      } else {
        lastMessageFormatted = createdDay.format("MM/DD");
      }
    }
    // var hasUnreadMessage = this.props.hasUnreadMessage;
    var unreadMessageCount =
      this.props.unreadMessageCount > 0 ? (
        <p className="badge--unread unread--message">
          {this.props.unreadMessageCount}
        </p>
      ) : (
        ""
      );
    var currentMessageGroupId = this.props.messageGroupId;
    var messageGroupId = this.props.messageGroup.id;
    var circleName = this.props.messageGroup.circle
      ? this.props.messageGroup.circle.name
      : "";
    var isSelected = "";
    if (currentMessageGroupId == messageGroupId) {
      isSelected = "is-selected";
    }

    var numOfUsers = (this.props.messageGroup.message_groups_users || [])
      .length;
    // var unreadBadge = hasUnreadMessage ? (
    //   <div style={{ display: "flex" }}>
    //     <span
    //       className="badge g-color-white g-bg-red g-ml-5"
    //       style={{ fontSize: "8px" }}
    //     >
    //       未読
    //     </span>
    //   </div>
    // ) : (
    //   ""
    // );
    var i = 0;
    var messageGroupUserImages = [];
    var messageGroupUserTitle = [];
    if (this.props.messageGroup.message_groups_users.length > 1) {
      this.props.messageGroup.message_groups_users.forEach(
        (groupUser, index) => {
          i++;
          if (groupUser.user.id != this.props.currentUserId && i < 4) {
            messageGroupUserImages.push(
              <div
                key={index}
                style={{
                  backgroundImage: `url(${groupUser.user.avatar_thumb})`,
                }}
              />
            );
          }
          if (
            groupUser.user.familyname &&
            groupUser.user.id != this.props.currentUserId
          ) {
            messageGroupUserTitle.push(
              `${this.fullname_disp(groupUser.user)}`
            );
          }
        }
      );
    } else {
      messageGroupUserTitle.push("ユーザーが退出しました");
    }

    let messageRoomUri = this.props.isCompany
      ? "/companies/companies_messages/room/" + this.props.messageGroup.id
      : "/message/room/" + this.props.messageGroup.id;
    var messageGroupBox = "";

    messageGroupBox = (
      <li>
        <a href={messageRoomUri} className={"hov--default " + isSelected}>
          <div
            className={`row justify-content-around align-items-center pt-3 pb-3 ${
              this.props.isLast ? "" : "border-bottom"
            }`}
          >
            <div className="col-2 pr-1">
              <div className="icon-group">{messageGroupUserImages}</div>
            </div>
            <div className="col-8 pl-3 pr-2">
              <p
                className="mb-1 line-1 position-relative pr-4"
                style={{ overflow: "scroll" }}
              >
                <span className="badge badge-light">{circleName}</span>
              </p>
              <p className="mb-1 line-1 position-relative pr-4">
                {messageGroupUserTitle.join(", ")}
                <span className="position-absolute position--messagenum">
                  ({numOfUsers})
                </span>
              </p>
              <p className="text-fz-14px text-black-20 mb-0 line-2">
                {this.props.lastMessage ? this.props.lastMessage.body : ""}
              </p>
            </div>
            <div className="col-2 p-0 align-self-start">
              <p className="text-fz-small text-black-20 mb-0 text-center">
                {lastMessageFormatted}
              </p>
              {unreadMessageCount}
            </div>
          </div>
        </a>
      </li>
    );
    return <div>{messageGroupBox}</div>;
  },
});
